<template>
  <v-card class="postContent" v-if="!isObjectEmpty(post)">
    <div>
      <PostHeaderMedia
        class="mb-6"
        v-if="isMedia"
        :item="post"
        @delete="onDelete"
      />
      <PostHeader v-else :item="post" @delete="onDelete" />

      <!-- panel body -->
      <v-row no-gutters class="rowContent" v-if="post.content">
        <!-- <p class="font-weight-bold">{{ post.title }}</p> -->
        <p class="mb-4" v-html="post.content"></p>
      </v-row>
      <slot></slot>

      <PostMedia
        :mediaList="post.media"
        :parent="{ type: 'post', id: post.id }"
      />

      <DiscussionPostAction
        :totalLike="post.totalLike"
        :isLiked="post.isLiked"
        :entityId="post.id"
        :entityName="'post'"
        @onLike="onLike"
        @onReply="onReplyPost"
      />
    </div>

    <v-divider class="my-6" v-if="token"></v-divider>
    <!-- reply post -->
    <DiscussionInput
      edit
      v-model="contentPost"
      :entityId="entityId"
      hideCancel
      @onSubmit="onSubmitPost"
      @onCancel="onCancelPost"
      v-show="isCreatePost"
    />

    <v-divider class="my-6"></v-divider>
    <!-- list comment -->
    <DiscussionPostComments
      :entityId="post.id"
      :items="post.comments"
      @onReplyComment="onReply"
    />
    <!-- reply comment -->
    <DiscussionInput
      ref="replyComment"
      edit
      v-model="content"
      :entityId="entityId"
      @onSubmit="onSubmit"
      @onCancel="onCancel"
      v-show="isCreate"
    />
  </v-card>
</template>
<script>
import { sleep } from "@/utils/helper";
import PostHeader from "@/components/Post/PostHeader";
import PostHeaderMedia from "@/components/Post/PostHeaderMedia";
import PostComments from "@/components/Post/PostComments/Main";
import PostMedia from "@/components/Post/PostMedia";
import DiscussionPostAction from "@/components/Post/Discussion/PostAction";
import DiscussionPostComments from "@/components/Post/Discussion/PostComments";
import DiscussionInput from "@/components/Forms/DiscussionInput";
export default {
  name: "DiscussionPost",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isMedia: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PostHeader,
    PostHeaderMedia,
    PostComments,
    PostMedia,
    DiscussionInput,
    DiscussionPostAction,
    DiscussionPostComments,
  },
  data() {
    return {
      post: [],
      contentPost: "",
      content: "",
      isCreate: false,
      isCreatePost: true,
    };
  },
  computed: {
    entityId() {
      return this.item.id;
    },
    medias() {
      let vm = this;
      let photos = vm.item.photos || [];
      let videos = vm.item.videos || [];
      let arr = [...photos, ...videos];
      return arr;
    },
    user() {
      return this.$store.state.auth.user;
    },
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        let comments = [];
        let data = { ...comments, ...val };
        this.post = data;
      },
    },
  },
  methods: {
    onDelete(id) {
      this.$router.push({ name: "community" }).catch((err) => {});
    },
    async onReply(val) {
      if (!val) return;
      this.isCreate = true;
      await sleep(200);
      const el = this.$refs.replyComment.$el;
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
        });
      }
      if (val.profile && val.profile.id !== this.$store.state.auth.user.id) {
        this.content = `<a href="/profiles/${val.profile.id}">@${val.profile.name}&nbsp;&nbsp;` + '</a>';
      } else {
        this.content = ''
      }
    },
    onSubmit(comment) {
      this.post.comments.push(comment);
      this.content = "";
    },
    onCancel() {
      this.content = "";
      this.isCreate = false;
    },
    onReplyPost() {
      let profile = this.post.profile;
      if (profile.id !== this.$store.state.auth.user.id) {
        this.contentPost = `<a href="/profiles/${profile.id}">@${profile.name}&nbsp;&nbsp;</a>`;
      }
    },
    onSubmitPost(comment) {
      this.post.comments.unshift(comment);
      this.contentPost = "";
    },
    onCancelPost() {
      this.contentPost = "";
    },
    onLike(item) {
      this.post.isLiked = item.isLiked;
    },
    // onLikeComments(temp) {
    //   this.post.comments = temp;

    //   if (temp) this.post.totalLike++;
    //   else this.post.totalLike--;
    // },
  },
};
</script>
